import { render, staticRenderFns } from "./PurchaseDetails.vue?vue&type=template&id=7c6a04d2&scoped=true&"
import script from "./PurchaseDetails.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDetails.vue?vue&type=style&index=0&id=7c6a04d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a04d2",
  null
  
)

export default component.exports